import React from "react";
import { KModal } from "../../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../../ui-kit/k-modal/k-modal-footer";
import { type IKuikaButtonStatusLabels, type KuikaButtonStatus } from "../../ui-kit/kuika-button/kuika-button";
import KuikaModalIconWrapper from "../../ui-kit/kuika-modal-icon-wrapper/kuika-modal-icon-wrapper";
import KuikaH5 from "../../ui-kit/typography/H5/H5";
import KuikaText from "../../ui-kit/typography/Text/Text";
import "./branching-modal.scss";

export interface IDiscardChangesModalProps {
  showModal: boolean;
  selectedCount: number;
  onClose: () => void;
  onDiscardChanges: () => void;
  /**
   * Where the discard stands (`KuikaButton` `status`): "Discarding", then its ✓ or "Try again".
   * The dialog stays up while it runs and closes once the ✓ has been seen.
   */
  status?: KuikaButtonStatus;
}

const DISCARD_STATUS_LABELS: IKuikaButtonStatusLabels = { loading: "Discarding", success: "Discarded" };

const DiscardChangesModal: React.FC<IDiscardChangesModalProps> = ({
  showModal,
  selectedCount,
  onClose,
  onDiscardChanges,
  status
}) => {
  const footer = (
    <KModalFooter
      closesOnSuccess
      onCancel={onClose}
      submitLabel="Discard anyways"
      submitTone="danger"
      onSubmit={onDiscardChanges}
      status={status}
      statusLabels={DISCARD_STATUS_LABELS}
    />
  );

  return (
    <KModal showModal={showModal} closeModal={onClose} header="Discard Changes" footer={footer} width={360} centered>
      <div className="kuika-branching-modal">
        <div className="kuika-branching-modal__header">
          <KuikaModalIconWrapper iconName="trash" intent="destructive" />
          <div className="kuika-branching-modal__title">
            <KuikaH5>Discard Selected Changes</KuikaH5>
          </div>
        </div>
        <div className="kuika-branching-modal__content">
          <div className="kuika-branching-modal__description">
            <KuikaText>
              Be aware that selecting this option will result in the loss of the chosen screens, and this process cannot
              be reversed.
            </KuikaText>
          </div>
        </div>
      </div>
    </KModal>
  );
};

export default DiscardChangesModal;
